import { useState, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import "@/App.css";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { RoleProblemSection } from "./components/RoleProblemSection";
import { SolutionSection } from "./components/SolutionSection";
import { WaitlistSection } from "./components/WaitlistSection";
import { SocialProof } from "./components/SocialProof";
import { Footer } from "./components/Footer";
import { NoiseOverlay } from "./components/NoiseOverlay";
import { NameModal } from "./components/NameModal";

function App() {
  const [showNameModal, setShowNameModal] = useState(false);
  const [userDancer, setUserDancer] = useState(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Check if user already has a dancer
    const savedDancer = localStorage.getItem('aya_user_dancer');
    if (savedDancer) {
      setUserDancer(JSON.parse(savedDancer));
      setIsReady(true);
    } else {
      // Show the name modal for new visitors
      setShowNameModal(true);
    }
  }, []);

  const handleNameComplete = (dancer) => {
    setUserDancer(dancer);
    setShowNameModal(false);
    setIsReady(true);
  };

  return (
    <div className="min-h-screen bg-aya-black" data-testid="aya-app">
      {/* Name Modal - Shows before site */}
      <AnimatePresence>
        {showNameModal && (
          <NameModal onComplete={handleNameComplete} />
        )}
      </AnimatePresence>

      {/* Main site content - shows after modal */}
      {isReady && (
        <>
          {/* Noise texture overlay */}
          <NoiseOverlay />
          
          {/* Sticky Header */}
          <Header />
          
          {/* Main Content */}
          <main>
            {/* Hero Section - Dictionary Style */}
            <HeroSection userDancer={userDancer} />
            
            {/* Problem Section - Interactive Role Selector */}
            <RoleProblemSection />
            
            {/* Solution Section - Feature Cards */}
            {/* <SolutionSection /> */}
            
            {/* Waitlist Section - Email Capture */}
            <WaitlistSection userName={userDancer?.name} />
            
            {/* Social Proof Section */}
            <SocialProof />
          </main>
          
          {/* Footer */}
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
